(function () {
const container = document.getElementById('accessoryContainer');
  const items = document.querySelectorAll('.accessory-item');

  let scrollAmount = 0;

  function scrollCarousel(direction) {
    const itemWidth = document.querySelector('.accessory-item').offsetWidth + 20; // Item width + padding
    const maxScroll = container.scrollWidth - container.clientWidth;

    scrollAmount += direction * itemWidth;

    if (scrollAmount >= maxScroll) {
      // Jump back to the start without showing the duplicated first item
      scrollAmount = maxScroll;
    }

    if (scrollAmount < 0) {
      // Jump to the end without showing the duplicated last item
      scrollAmount = 0;
    }

    container.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  document.getElementById('accessoryLeftArrow').addEventListener('click', () => scrollCarousel(-1));
  document.getElementById('accessoryRightArrow').addEventListener('click', () => scrollCarousel(1));
})();